import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Spinner from '../../../components/widgets/Spinner';
import SunburstChart from './SunburstChart';
import ChartLegend from './ChartLegend';
import css from './Sunburst.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANOMALY_ANALYSIS';

const Sunburst = ({
    data,
    isLoading,
    error,
    hasQueried,
    chartColors,
    metricLabels,
    displayFormats,
    increasesAreGood,
    onDrilldown,
    firstPeriod,
    secondPeriod,
}) => {
    const hasData = data?.length > 0;

    return (
        <div className={css.container}>
            <div className={css.headerWrapper}>
                <div>
                    <div className={css.title}>
                        <Translate id={`${TRANSLATION_PREFIX}.PAGE_TITLE`} />
                    </div>
                    <div className={css.subtitle}>
                        <Translate id={`${TRANSLATION_PREFIX}.PAGE_SUBTITLE`} />
                    </div>
                </div>
            </div>
            <div className={css.chartCard}>
                {hasData && !isLoading && <ChartLegend chartColors={chartColors} />}
                <div className={css.content}>
                    {isLoading ? (
                        <Spinner show />
                    ) : error ? (
                        <Translate id={`${TRANSLATION_PREFIX}.SUNBURST.ERROR_STATE`} />
                    ) : !hasData ? (
                        <Translate id={`${TRANSLATION_PREFIX}.SUNBURST.${hasQueried ? 'NO_RESULTS' : 'EMPTY_STATE'}`} />
                    ) : (
                        <SunburstChart
                            data={data}
                            metricLabels={metricLabels}
                            displayFormats={displayFormats}
                            increasesAreGood={increasesAreGood}
                            onDrilldown={onDrilldown}
                            firstPeriod={firstPeriod}
                            secondPeriod={secondPeriod}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

Sunburst.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            parent: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            value: PropTypes.number.isRequired,
            color: PropTypes.string.isRequired,
            custom: PropTypes.shape({
                colorP1: PropTypes.number,
                colorP2: PropTypes.number,
                rawColorChange: PropTypes.number,
                rawColorChangePct: PropTypes.number,
                sizeP1: PropTypes.number,
                sizeP2: PropTypes.number,
                rawSizeChange: PropTypes.number,
                rawSizeChangePct: PropTypes.number,
                ringLevel: PropTypes.number,
                originalColor: PropTypes.string,
            }),
        })
    ),
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    hasQueried: PropTypes.bool,
    chartColors: PropTypes.shape({
        positive: PropTypes.string,
        negative: PropTypes.string,
        neutral: PropTypes.string,
        noData: PropTypes.string,
    }),
    metricLabels: PropTypes.shape({
        color: PropTypes.string,
        size: PropTypes.string,
    }),
    displayFormats: PropTypes.shape({
        color: PropTypes.string,
        size: PropTypes.string,
    }),
    increasesAreGood: PropTypes.bool,
    onDrilldown: PropTypes.func,
    firstPeriod: PropTypes.shape({ start: PropTypes.string, end: PropTypes.string }),
    secondPeriod: PropTypes.shape({ start: PropTypes.string, end: PropTypes.string }),
};

export default Sunburst;
